import React, { useState } from "react"
import { graphql } from "gatsby"

import Layout from "../../components/layout/layout"
import Meta from "../../components/addon/meta"
import Schema from "../../components/addon/schema"
import BtnLink from "../../components/addon/Link"

const CertificateCourseInRadiologyTechnician = ({ data: { allNodeTemplatePages: { edges } } }) => {

    const rawData = edges[0]
    const metaTags = rawData.node?.metatag_normalized.length > 0 ? rawData?.node?.metatag_normalized : [];
    const schema = rawData?.node?.relationships?.field_seo_schema ? rawData?.node?.relationships?.field_seo_schema : []
    const data = rawData?.node?.relationships?.components;

    const [ ,saveLivesData] = data
    console.log("data", saveLivesData)
    
    const bannerData = Array.isArray(data) && data.length > 0 && data[0];
    const bannerImg = typeof(bannerData?.relationships?.components?.[0]?.relationships?.bannerImage?.uri?.url) !== "undefined" ? bannerData?.relationships?.components?.[0]?.relationships?.bannerImage?.uri?.url?.replace('http://', 'https://') : "/assets/images/patient_care/banner_patient_care.jpg"
    const mobileBannerImg = bannerData?.relationships?.components?.[0]?.relationships?.mobileBannerImage?.uri?.url?.replace('http://', 'https://') || bannerImg;
    const bannerAlt = typeof(bannerData?.relationships?.components?.[0]?.bannerImage?.alt) !== "undefined" && bannerData?.relationships?.components?.[0]?.bannerImage?.alt.length > 0 ? bannerData?.relationships?.components?.[0]?.bannerImage?.alt : "Hinduja Hospital"
    const bannerTitle = typeof(bannerData?.relationships?.components?.[0]?.title) !== "undefined" && bannerData?.relationships?.components?.[0]?.title.length > 0 ? bannerData?.relationships?.components?.[0]?.title : "";
    const bannerSubtitle = typeof(bannerData?.relationships?.components?.[0]?.subtitle) !== "undefined" && bannerData?.relationships?.components?.[0]?.subtitle.length > 0 ? bannerData?.relationships?.components?.[0]?.subtitle : "";
     
    // saveLivesSection
    const saveLivesTitle = saveLivesData?.relationships?.components[0]?.field_title || ''
    const saveLivesDescription = saveLivesData?.relationships?.components[0]?.text?.processed || ''

    return (
        <>
            <Layout>
                <Meta
                    files={{
                        js: [],
                        css: ["/assets/css/academics.css", "/assets/css/accessibility.css", "/assets/css/philanthrophy.css"],
                    }}
                    tags={metaTags}
                />
                <Schema schema={schema} />
                <main className="innerpage pt-first-section">
                    <section className="inner_common_banner">
                        <picture className="banner_img">
                          <img src={mobileBannerImg} alt={bannerAlt} className="d-md-none"/>
                          <img src={bannerImg} alt={bannerAlt} className="d-md-block d-none"/>
                        </picture>
                        <div className="banner_content text_left text_dark">
                            <div className="container">
                                <h1>{bannerTitle}</h1>
                                <p>{bannerSubtitle}</p>
                            </div>
                        </div>
                    </section>
                   <section className="section_bg pt-first-section pb-section philanthrophy-section">
                      <div className="container">
                        <div className="save-lives-wrap">
                              <div className="para_text pb-4">
                                  <h2>{saveLivesTitle}</h2>
                              </div>
                              <div className="para_text pb-4" dangerouslySetInnerHTML={{ __html: saveLivesDescription }}>
                              </div>
                          </div>  
                        </div>
                   </section>
                </main>
            </Layout>
        </>
    )
}

export const query = graphql`
query certificateCourseInRadiologyTechnician {
  allNodeTemplatePages(
    filter: {path: {alias: {regex: "/certificate-course-in-radiology-technician$/"}}}
  ) {
    edges {
      node {
        id
        title
        path {
          alias
        }
        relationships {
          field_seo_schema {
            field_seo_title
            field_seo_schema_text_area
          }
        }
        metatag_normalized {
          attributes {
            content
            name
            property
          }
        }
        relationships {
          components: field_component_type {
            __typename
            ...acaParagraphSections
          }
        }
      }
    }
  }
}

fragment acaParagraphSections on paragraph__section {
  id
  name: field_name
  relationships {
    components: field_components {
      __typename
      ...acaParagraphBanner
      ...phParagraphTitleAndDescription
    }
  }
}

fragment acaParagraphBanner on paragraph__banner {
  id
  title: field_title
  subtitle: field_subtitle
  bannerImage: field_banner_image {
    alt
  }
  mobileBannerImage: field_mobile_banner {
    alt
  }
  bannerLink: field_banner_link {
    uri
    title
  }
  relationships {
    bannerImage: field_banner_image {
      id
      uri {
        value
        url
      }
    }
    mobileBannerImage: field_mobile_banner {
      id
      uri {
        url
        value
      }
    }
  }
}

fragment phParagraphTitleAndDescription on paragraph__title_and_description {
  id
  field_title
  text: field_description {
    processed
  }
  field_cta_link {
    title
    uri
  }
  field_text {
    processed
  }
}
`
export default CertificateCourseInRadiologyTechnician